import {createReducer} from "typesafe-actions";
import {TournamentWithCategoryId} from "../../../models/api/codegen/code";
import {CHANGE_SELECTED_TOURNAMENT} from "../actions";

const initialValue = null;

export const selectedTournamentReducer = createReducer<TournamentWithCategoryId | null>(initialValue)
    .handleAction(CHANGE_SELECTED_TOURNAMENT, (state, action) => action.payload.selectedTournament);
